<div class="section bg-col-4" *ngIf="title && description">
        <p class="font-secondary title">{{title}}</p>
        <p class="font-primary description" [innerHTML]="description"></p>
</div>
